export enum MeetingModeEnum {
  ONLINE = 'online',
  OFFLINE = 'offline',
}
